import Vue from 'vue';

export default () => {
	const el = document.getElementById('header');

	if (!el) {
		return;
	}

	new Vue({
		el,

		data: {
			menuVisible: false,

			// used to apply visibility: hidden
			// to the menu once it is closed to prevent
			// tabbing through the menu items
			menuFinishedCollapsing: true,

			// track which submenu is open by index.
			// -1 indicates that no submenu is active
			activeSubmenu: -1,

			languageSwitcherToggled: false,

			pastFold: false,
		},

		// computed properties behave like normal data
		// but can contain some logic. They are accessed
		// in the same way to normal properties i.e. by
		// referencing their name but not calling the method
		computed: {
			headerClass() {
				let className = '';
				if (this.pastFold) {
					className += 'header--min';
				} else {
					className += 'header';
				}

				if (this.menuVisible) {
					className += ' header--visible';
				} else if (this.menuFinishedCollapsing) {
					className += ' header--collapsed';
				}

				return className;
			},

			navClass() {
				if (this.menuVisible) {
					return 'header__nav--visible';
				} else if (this.menuFinishedCollapsing) {
					return 'header__nav--collapsed';
				} else {
					return 'header__nav';
				}
			},

			toggleClass() {
				return this.menuVisible ? 'header__toggle--close' : 'header__toggle';
			},

			toggleAriaLabel() {
				return `${ this.menuVisible ? 'close' : 'open' } the primary navigation menu`;
			},
		},

		methods: {
			onResize() {
				// collapse nav when resizing the browsers
				this.menuVisible = false;
				this.menuFinishedCollapsing = true;

				document.body.style.overflow = this.menuVisible ? 'hidden' : '';
				document.body.style.maxHeight = this.menuVisible ? '100vh' : '';
			},

			onScroll() {
				this.pastFold = window.pageYOffset > 150;
			},

			toggle() {
				this.menuVisible = !this.menuVisible;

				document.body.style.overflow = this.menuVisible ? 'hidden' : '';
				document.body.style.maxHeight = this.menuVisible ? '100vh' : '';

				this.menuFinishedCollapsing = !this.menuVisible;
			},

			toggleSubmenu(id) {
				this.activeSubmenu =
					this.activeSubmenu === id
					// set to -1 for no submenu active if clicking on the already active menu
					? -1
					: id;
			},

			getSubmenuIconClass(id) {
				return this.activeSubmenu === id ? 'header__subtoggle__icon--active' : 'header__subtoggle__icon';
			},

			getSubmenuAriaLabel(id, menuName) {
				return `${ this.activeSubmenu === id ? 'close' : 'open' } menu for ${ menuName.toLowerCase() }`;
			},

			toggleLanguage() {
				this.languageSwitcherToggled = !this.languageSwitcherToggled;
			},
		},

		mounted() {
			window.addEventListener('resize', this.onResize);
			window.addEventListener('scroll', this.onScroll);
		},

		beforeDestroy() {
			// clean up resize listener
			window.removeEventListener('resize', this.onResize);
		},
	});
};


// WEBPACK FOOTER //
// ./scripts/modules/header.js